import * as React from 'react';

function SvgCalendar(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 101 100"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M79.842 16.67h-8.333v-4.166a4.167 4.167 0 10-8.334 0v4.167h-25v-4.167a4.167 4.167 0 00-8.333 0v4.167h-8.333a12.5 12.5 0 00-12.5 12.5v50a12.5 12.5 0 0012.5 12.5h58.333a12.5 12.5 0 0012.5-12.5v-50a12.5 12.5 0 00-12.5-12.5zm4.167 62.5a4.166 4.166 0 01-4.167 4.167H21.509a4.167 4.167 0 01-4.167-4.166V50.004h66.667v29.167zm0-37.5H17.342v-12.5a4.167 4.167 0 014.167-4.166h8.333v4.167a4.167 4.167 0 108.333 0v-4.167h25v4.167a4.167 4.167 0 108.334 0v-4.167h8.333a4.166 4.166 0 014.167 4.167v12.5z" />
    </svg>
  );
}

export default SvgCalendar;
